/**
 * Regelversion 2: Vorhaben aus den Meinungsthemen.
 *
 * Zu jedem der 18 Meinungsthemen gibt es Gesetze, die man jederzeit anstoßen kann, auch wenn das
 * zugehörige Problem gerade nicht auf der Liste steht. Meist sind das vorhandene Ansätze aus den
 * Problemen (mit passender Voreinstellung), für Themen ohne Gesetz gibt es eigene Vorlagen.
 *
 * Die eigenen Vorlagen hängen an „Themen“ (ag_…), die nur im Nachschlagewerk ISS stehen, nicht in
 * ISSUES. Dadurch ändern sie nichts an Partien nach Regelversion 1 (kein zusätzlicher Zufall, keine
 * neuen Probleme).
 */
import { ISS } from './states';

/** Eigene Vorlagen für Themen, zu denen es noch kein Gesetz gab. */
const AG_ISSUES: any[] = [
  { id: 'ag_mindestlohn', n: 'Mindestlohn', d: 'Wie hoch soll die Lohnuntergrenze sein?', sev: 0, rate: 0, imp: {}, agenda: true, laws: [
    { t: 'Mindestlohngesetz', r: 'Arbeit und Soziales', br: 0, d: 'Den gesetzlichen Mindestlohn per Gesetz anheben, statt auf die Kommission zu warten.', ps: [
      { id: 'h', l: 'Mindestlohn pro Stunde', k: 'c', o: ['14 €', '15 €', '16 €'], d: 1 },
      { id: 'ab', l: 'Ausnahmen für Minijobs und Auszubildende', k: 'b', d: 1 }],
    fx: (p: any) => ({ months: 2, b: .3 + p.h * .3, sev: 0, cut: 0,
      g: { arb: 2 + p.h * 1.5 - p.ab * .5, jung: 1 + p.h - p.ab * .8, fam: .5 + p.h * .5, unt: -(1.5 + p.h * 1.5) + p.ab },
      gr: -.01 * p.h, al: .04 * p.h - p.ab * .03,
      pos: { mindestlohn: .8 + p.h * .5, sozial: .3 + p.h * .3, buero: -.5 - p.h * .3 } }) }] },
  { id: 'ag_tempo', n: 'Tempolimit', d: 'Soll es auf Autobahnen ein generelles Tempolimit geben?', sev: 0, rate: 0, imp: {}, agenda: true, laws: [
    { t: 'Tempolimit-Gesetz', r: 'Verkehr', br: 0, d: 'Eine allgemeine Höchstgeschwindigkeit auf Autobahnen. Kostet nichts, spart CO₂ und Unfälle.', ps: [
      { id: 'v', l: 'Höchstgeschwindigkeit', k: 'c', o: ['150 km/h', '130 km/h', '120 km/h'], d: 1 }],
    fx: (p: any) => ({ months: 1, b: 0, sev: 0, cut: 0,
      g: { jung: 1 + p.v * .5, fam: .3, rent: -.5, arb: -1 - p.v * .5, unt: -.5 },
      gr: 0, pos: { tempo: 1 + p.v * .5, klima: .5 + p.v * .3, verkehr: .3 } }) }] },
  { id: 'ag_bildung', n: 'Bildung in Bundeshand', d: 'Soll der Bund mehr Verantwortung für Schulen übernehmen?', sev: 0, rate: 0, imp: {}, agenda: true, laws: [
    { t: 'Bundesbildungsgesetz', r: 'Bildung', br: 1, d: 'Das Kooperationsverbot fällt, der Bund finanziert Schulen mit und setzt gemeinsame Standards. Braucht eine Grundgesetzänderung.', ps: [
      { id: 'bund', l: 'Bund finanziert Schulen mit', k: 'r', min: 0, max: 8, st: 1, u: ' Mrd €/J', d: 3 },
      { id: 'std', l: 'Bundesweite Abschlussprüfungen', k: 'b', d: 1 }],
    fx: (p: any) => ({ months: 4, b: -p.bund, gg: 1, sev: 0, cut: 0,
      g: { fam: p.bund * .5 + p.std, jung: p.bund * .4 + p.std * .5, arb: p.bund * .1 },
      gr: p.bund * .01, pos: { bildung: 1 + p.bund * .1 + p.std * .4, haushalt: -.5 + p.bund * .1, sozial: .3 } }) }] },
  { id: 'ag_europa', n: 'Europäische Integration', d: 'Mehr oder weniger Europa?', sev: 0, rate: 0, imp: {}, agenda: true, laws: [
    { t: 'Europagesetz', r: 'Finanzen', br: 1, d: 'Legt fest, wie eng Deutschland mit der EU zusammenarbeitet und wie viel es zum EU-Haushalt beiträgt.', ps: [
      { id: 'eu', l: 'Richtung', k: 'c', o: ['Mehr nationale Souveränität', 'Zusammenarbeit stärken', 'Mehr Kompetenzen nach Brüssel'], d: 2 },
      { id: 'bt', l: 'Zusätzlicher EU-Beitrag', k: 'r', min: 0, max: 6, st: 1, u: ' Mrd €/J', d: 2 }],
    fx: (p: any) => ({ months: 3, b: -p.bt, sev: 0, cut: 0,
      g: { unt: (p.eu - 1) * 1 + p.bt * .3, jung: (p.eu - 1) * 1, rent: -(p.eu - 1) * .8 },
      gr: (p.eu - 1) * .02 + p.bt * .004, pos: { europa: (p.eu - 1) * 1.2 + p.bt * .15, haushalt: -.3 } }) }] },
  { id: 'ag_agrar', n: 'Agrarwende', d: 'Soll die Landwirtschaft ökologischer werden?', sev: 0, rate: 0, imp: {}, agenda: true, laws: [
    { t: 'Agrarwendegesetz', r: 'Landwirtschaft', br: 1, d: 'Mehr Ökolandbau und Tierwohl, mit Geld für den Umbau der Höfe.', ps: [
      { id: 'oeko', l: 'Ziel für Ökolandbau', k: 'c', o: ['20 %', '30 %', '40 %'], d: 1 },
      { id: 'tw', l: 'Tierwohlabgabe auf Fleisch', k: 'b', d: 0 },
      { id: 'hilfe', l: 'Umbauhilfe für Höfe', k: 'r', min: 0, max: 4, st: .5, u: ' Mrd €/J', d: 1.5 }],
    fx: (p: any) => ({ months: 3, b: -p.hilfe + p.tw * 1.5, sev: 0, cut: 0,
      g: { fam: -p.tw * 1.5 - p.oeko * .5, rent: -p.tw - p.oeko * .3, jung: 1 + p.oeko * .8, unt: -p.oeko * .5 + p.hilfe * .3 },
      gr: -.005 * p.oeko, pos: { agrar: .8 + p.oeko * .5 + p.tw * .5, klima: .3 + p.oeko * .3 } }) }] },
];
for (const I of AG_ISSUES) (ISS as any)[I.id] = I;
export const AG_IDS = AG_ISSUES.map((i) => i.id);

/**
 * Zusätzliche Programm-Positionen vorhandener Ansätze (nur Regelversion 2), damit z. B. die
 * Bürgerversicherung auch beim Thema „Bürgerversicherung“ zählt.
 */
export const V2POS: Record<string, (p: any) => Record<string, number>> = {
  'Bürgerversicherung': () => ({ buergerv: 1.6 }),
  'Agrarentlastungsgesetz': () => ({ agrar: -1 }),
  'Faire Preise in der Lieferkette': () => ({ agrar: .8 }),
  'Klimaschutzprogramm': (p): Record<string, number> => (p.tl ? { tempo: 1.2 } : {}),
  'Startchancen-Programm ausweiten': () => ({ bildung: .8 }),
  'Digitalpakt Schule 2.0': () => ({ bildung: .6 }),
};

/** Ein Vorhaben: Ansatz `k` beim Problem oder Thema `iss`, optional mit Voreinstellungen. */
export type AgendaItem = { iss: string; k: number; set?: Record<string, number>; /** Name, wenn die Voreinstellung den Unterschied macht */ label?: string };

/** Vorhaben je Meinungsthema (Reihenfolge = Anzeige). */
export const AGENDA: Record<string, AgendaItem[]> = {
  sozial: [{ iss: 'kinderarmut', k: 0 }, { iss: 'fach', k: 1 }],
  haushalt: [{ iss: 'infra', k: 3 }, { iss: 'infra', k: 0 }],
  klima: [{ iss: 'klima', k: 0 }, { iss: 'klima', k: 1 }, { iss: 'netze', k: 1 }],
  migration: [{ iss: 'fach', k: 0 }, { iss: 'asyl', k: 2 }],
  sicherheit: [{ iss: 'wehr', k: 0 }, { iss: 'wehr', k: 1 }],
  steuern: [{ iss: 'steuer', k: 2 }, { iss: 'steuer', k: 0, set: { sp: 2 }, label: 'Spitzensteuersatz erhöhen' }, { iss: 'steuerbetrug', k: 0 }, { iss: 'industrie', k: 1 }],
  wohnen: [{ iss: 'wohnen', k: 2 }, { iss: 'wohnen', k: 1 }],
  rente: [{ iss: 'rente', k: 0, set: { a: 1 }, label: 'Rentenalter an Lebenserwartung koppeln' }, { iss: 'rente', k: 0, set: { a: 2 }, label: 'Früher in Rente mit 65' }],
  innen: [{ iss: 'sicher', k: 0 }, { iss: 'desinfo', k: 0 }],
  verkehr: [{ iss: 'infra', k: 1 }, { iss: 'ag_tempo', k: 0 }],
  buero: [{ iss: 'digital', k: 1 }, { iss: 'digital', k: 0 }, { iss: 'agrar', k: 1 }],
  atom: [{ iss: 'energie', k: 2 }],
  bildung: [{ iss: 'ag_bildung', k: 0 }, { iss: 'bildung', k: 1 }],
  europa: [{ iss: 'ag_europa', k: 0 }],
  buergerv: [{ iss: 'gkv', k: 2 }],
  mindestlohn: [{ iss: 'ag_mindestlohn', k: 0 }],
  tempo: [{ iss: 'ag_tempo', k: 0 }, { iss: 'klima', k: 0, set: { tl: 1 }, label: 'Klimaschutzprogramm mit Tempolimit' }],
  agrar: [{ iss: 'ag_agrar', k: 0 }, { iss: 'agrar', k: 0 }],
};
